import * as ActionTypes from 'app/types'

const initialState = {
    loading:false,
    error : null,
    data: [
        // {
        //     role: "super_admin",
        //     version: 0,
        //     isActivated: true,
        //     _id: "607a2e3a40191b0ef460fd91",
        //     email: "hm_mostefa@esi.dz",
        //     authorities: [
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd92",
        //             entity: "points"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd93",
        //             entity: "payments"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd94",
        //             entity: "timeslots"
        //         },
        //         {
        //             has: {
        //                 read: true,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd95",
        //             entity: "lines"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd96",
        //             entity: "bookings"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd97",
        //             entity: "trips"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd98",
        //             entity: "drivers"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd99",
        //             entity: "riders"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd9a",
        //             entity: "notifications"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd9b",
        //             entity: "code promo"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd9c",
        //             entity: "contactus"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a2e3a40191b0ef460fd9d",
        //             entity: "users"
        //         }
        //     ],
        //     createdAt: "2021-04-17T00:39:22.907Z",
        //     updatedAt: "2021-04-17T00:39:22.907Z",
        //     __v: 0
        // },
        // {
        //     role: "marketing",
        //     version: 0,
        //     isActivated: false,
        //     _id: "607a339cf531931043a3c163",
        //     email: "hm_mostefa1@esi.dz",
        //     authorities: [
        //         {
        //             has: {
        //                 read: true,
        //                 write: true
        //             },
        //             _id: "607a47c239f7e71500d21ee6",
        //             entity: "points"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c165",
        //             entity: "payments"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c166",
        //             entity: "timeslots"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c167",
        //             entity: "lines"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c168",
        //             entity: "bookings"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c169",
        //             entity: "trips"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16a",
        //             entity: "drivers"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16b",
        //             entity: "riders"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16c",
        //             entity: "notifications"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16d",
        //             entity: "code promo"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16e",
        //             entity: "contactus"
        //         },
        //         {
        //             has: {
        //                 read: false,
        //                 write: false
        //             },
        //             _id: "607a339cf531931043a3c16f",
        //             entity: "users"
        //         },
        //         {
        //             has: {
        //                 read: true,
        //                 write: true
        //             },
        //             _id: "607a47f539f7e71500d21ee7",
        //             entity: "cars"
        //         }
        //     ],
        //     createdAt: "2021-04-17T01:02:20.728Z",
        //     updatedAt: "2021-04-17T02:29:09.072Z",
        //     __v: 3
        // }
    ]
}

export default function dashboardUsersReducer (state = initialState, action) {

    switch(action.type){
        // GET DASHBOARD USERS
        case ActionTypes.GET_DASHBOARD_LOADING :
            return {
                ...state ,
                loading : true
            }
        case ActionTypes.GET_DASHBOARD_USERS:
            return {
                ...state,
                data : action.payload ,
                loading : false
            }
        case ActionTypes.DASHBOARD_USERS_ERROR :
            return {
                loading: false ,
                error : action.payload
            }
        // POST NEW USER
        case ActionTypes.DASHBOARD_ADD_USERS :
            let newData = state.data.concat(action.payload)
            return {
                ...state ,
                data : newData  ,
                loading : false ,
                errorAddUser : null
            }
        case ActionTypes.DASHBOARD_ADD_USERS_ERROR :
            return {
                ...state,
                loading: false ,
                errorAddUser : action.payload
            }
        // DEACTIVATE/ACTIVATE USER
        case ActionTypes.DASHBOARD_ACTIVATE_USER:
            const indexUserActivate = state.data.findIndex(admin => admin._id ===action.payload.id_admin);
            const newDataActivateUser =[...state.data];
            newDataActivateUser[indexUserActivate].isActivated=true;
            return {
                ...state,
                loading: false,
                errorActivateUser: null,
                data : newDataActivateUser
            }
        case ActionTypes.DASHBOARD_DEACTIVATE_USER:

            const indexUserDeactivate = state.data.findIndex(admin => admin._id ===action.payload.id_admin);
            const newDataDeactivateUser =[...state.data];
            newDataDeactivateUser[indexUserDeactivate].isActivated=false;
            return {
                ...state,
                loading: false,
                errorActivateUser: null,
                data : newDataDeactivateUser
            }
        case ActionTypes.DASHBOARD_DEACTIVATE_ACTIVATE_USER_ERROR :
            return {
                ...state ,
                loading: false ,
                errorActivateUser : action.payload
            }

        // UPDATE AUTHORITIES

        case ActionTypes.DASHBOARD_UPDATE_USER_AUTHORITIES:
            const indexUserUpdated = state.data.findIndex(admin => admin._id ===action.payload._id);
            const newDataUserUpdated =[...state.data];
            newDataUserUpdated[indexUserUpdated]=action.payload;
            return {
                ...state ,
                loading : false ,
                errorUpdateAuthorities : null,
                data : newDataUserUpdated
            }
        case ActionTypes.DASHBOARD_UPDATE_USER_AUTHORITIES_ERROR:
            return {
                ...state ,
                loading : false ,
                errorUpdateAuthorities : action.payload
            }
        case ActionTypes.DASHBOARD_ADD_NEW_AUTHORITY_USER_DASHBAORD:
            return {
                ...state ,
                loading: false,
                error : null
            }
        default: return state
    }

}

